export default {
      id: "icon-multiple-pouce-usage",
      viewBox: "0 0 98.8 111",
      url: __webpack_public_path__ + "icons.svg#icon-multiple-pouce",
      toString: function () {
        return this.url;
      }
    }